import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=c0c04dbc&scoped=true&"
import script from "./tabla.vue?vue&type=script&lang=js&"
export * from "./tabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c04dbc",
  null
  
)

export default component.exports